<template>
  <div>
    <div class="tw-grid tw-grid-cols-2">
      <div>
        <PrintTest 
          v-if="printEnabled"
          :maths-test-id="currentResultId" 
          :score="currentResult" 
        />
      </div>
      <div>
        <select
          v-if="testResults.length > 1"
          v-model="currentTestIndex"
          class="sf-form-control"
        >
          <option
            v-for="(tr, index) in testResults"
            :key="tr.id"
            :value="index"
          >
            {{ $filters.timeFormat(tr.createdon, "[dn] [d] [mn] [y] [h]:[i]", true) }}
          </option>
        </select>
      </div>
    </div>
    <div v-if="currentResult !== null">
      <div>
        <div>
          Date of test:
          <br>
          {{ $filters.timeFormat(currentResult.createdon, "[dn] [d] [mn] [y] [h]:[i]", true) }}
        </div>
        <div v-if="student">Student: {{ student.fullName }}</div>
      </div>
      <div class="tw-grid tw-grid-cols-3 tw-text-center">
        <div>
          <div>Completed</div>
          <div v-if="wasCompleted">Yes</div>
          <div v-else>No</div>
        </div>
        <div>
          <div>Answers</div>
          <div v-if="wasCompleted">
            {{ currentResult.total_answers }}
          </div>
          <div v-else>
            {{ currentResult.total_answers }} /
            {{ currentResult.question_count }}
          </div>
        </div>
        <div>
          <div>Correct Answers</div>
          <div>
            {{ currentResult.correct_answers }} ({{
              $filters.renderPercent(
                currentResult.correct_answers / currentResult.total_answers,
              )
            }})
          </div>
        </div>
      </div>
      <table class="sf-table tw-w-full">
        <thead>
          <tr>
            <th>Question</th>
            <th class="!tw-text-center tw-text-nowrap">Your Answer</th>
            <th class="!tw-text-center tw-text-nowrap">Correct Answer</th>
          </tr>
        </thead>
        <tbody>
          <MathsTestResultItem
            v-for="(r, idx) in questions"
            :key="idx"
            :question="r"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import apiCall from "@/func/net/apiCall";
import { SfTestResultInfo, SfUser } from "@/types/generalTypes";
import { SfMathsTestResult, SfMathTestQuestion } from "@/types/mathsTypes";
import { defineComponent, PropType } from "vue";
import PrintTest from "./PrintTest.vue";
import MathsTestResultItem from "./MathsTestResultItem.vue";

export default defineComponent({
  components: { PrintTest, MathsTestResultItem },
  props: {
    student: { type: Object as PropType<SfUser | null> },
    testResultInfo: { type: Object as PropType<SfTestResultInfo> },
    result: Object as PropType<SfMathsTestResult | null>,
  },
  data() {
    return {
      currentTestIndex: 0,
      testResults: [] as SfMathsTestResult[],
      printEnabled: false,
    };
  },
  computed: {
    currentResult(): SfMathsTestResult | null {
      if (this.testResults.length < 1) {
        return null;
      }
      return this.testResults[this.currentTestIndex];
    },
    currentResultId(): number {
      return this.$filters.getNumber(this.currentResult?.id);
    },
    questions(): SfMathTestQuestion[] {
      return this.currentResult?.questionsWithFormat || 
        this.currentResult?.questions || 
        [];
    },
    wasCompleted() {
      if(!this.currentResult) {
        return false;
      }
      return this.currentResult.total_answers >= this.currentResult.question_count;
    }
  },
  mounted() {
    if (this.result) {
      this.testResults = [this.result];
      return;
    }
    this.refreshResults();
  },
  methods: {
    async refreshResults() {
      if (!this.student) {
        return;
      }
      this.currentTestIndex = 0;
      const params = {
        ...this.testResultInfo,
        expand: "questionsWithFormat",
        studentId: this.student.id,
        all: 1,
      };
      const resData = await apiCall("math-test", params);
      if (resData.success) {
        this.testResults = resData.data.items;
        this.$emit("dataloaded");
      }
    },
  },
});
</script>
